<template>
  <div>
    <table class="achievements mt-3">
      <thead>
      <tr>
        <th scope="col">#</th>
        <th scope="col">Member</th>
        <th scope="col">Designation</th>
        <th scope="col">Photo</th>
      </tr>
      </thead>
      <tbody>
      <tr class="text-justify" v-for="(member,index) in members"
          :key="index">
        <td>{{ member.sr }}</td>
        <td>{{ member.name }}</td>
        <td>{{ member.designation }}</td>
        <td>
          <img
              class="w-5 sm:w-auto object-fill rounded-lg transition duration-500 ease-in-out transform  hover:scale-105"
              :src="`/static/images/${dir}/studentClub/committee/${member.photo}.jpg`" alt="member">
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "TableCommittee",
  props: {
    members: Object,
    dir: String
  }
}
</script>

<style lang="scss" scoped/>